import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly TOKEN_KEY = 'auth_token';
  private readonly USER_ID_KEY = 'user_id';

  getToken(): string | null {
    return this.getString(this.TOKEN_KEY);
  }

  setToken(token: string): void {
    this.setString(this.TOKEN_KEY, token);
  }

  clearToken(): void {
    this.remove(this.TOKEN_KEY);
  }

  getUserId(): string | null {
    return this.getString(this.USER_ID_KEY);
  }

  setUserId(userId: string): void {
    this.setString(this.USER_ID_KEY, userId);
  }

  clearUserId(): void {
    this.remove(this.USER_ID_KEY);
  }

  setString(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getString(key: string): string | null {
    return localStorage.getItem(key);
  }

  setBool(key: string, value: boolean): void {
    this.setString(key, String(value));
  }

  getBool(key: string): boolean | null {
    const value = this.getString(key);
    if (value === null) return null;
    return value.toLowerCase() === 'true';
  }

  setInt(key: string, value: number): void {
    this.setString(key, String(value));
  }

  getInt(key: string): number | null {
    const value = this.getString(key);
    if (value === null) return null;
    return parseInt(value, 10);
  }

  setDouble(key: string, value: number): void {
    this.setString(key, String(value));
  }

  getDouble(key: string): number | null {
    const value = this.getString(key);
    if (value === null) return null;
    return parseFloat(value);
  }

  setStringList(key: string, value: string[]): void {
    this.setString(key, JSON.stringify(value));
  }

  getStringList(key: string): string[] | null {
    const value = this.getString(key);
    if (value === null) return null;
    try {
      return JSON.parse(value) as string[];
    } catch {
      return null;
    }
  }

  setObject(key: string, value: Record<string, any>): void {
    this.setString(key, JSON.stringify(value));
  }

  getObject<T>(key: string): T | null {
    const value = this.getString(key);
    if (value === null) return null;
    try {
      return JSON.parse(value) as T;
    } catch {
      return null;
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}